/* eslint-disable @typescript-eslint/no-empty-function */
import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/x5GMaps';
import i18n from './i18n';

if (process.env.NODE_ENV !== 'development') {
  console.log = function () {};
  console.error = function () {};
  console.warn = function () {};
  console.info = function () {};
  console.debug = function () {};
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  created() {
    const userString = localStorage.getItem('user');
    if (userString) {
      const userData = JSON.parse(userString);
      this.$store.commit('user/setUser', userData);
    }
    axios.interceptors.response.use(
      (res) => res,
      (error) => {
        console.log(error.response);
        if (error.response.status === 401) {
          this.$router.push({ name: 'Error' });
          this.$store.dispatch('user/logout');
        }
        return Promise.reject(error);
      },
    );
  },
  render: (h) => h(App),
}).$mount('#app');
